import { useParams } from 'react-router-dom';
import CopyTxtIconBtn from '../../components/CopyTxtIconBtn';
import { useContext } from 'react';
import { LabContext } from '../../context/lab';
import {useQuery} from "@tanstack/react-query";
import { fetchBlockTxs } from '../../services';
import { Divider } from '@mui/material';
import LoadingWrapper from '../../components/LoadingWraper';
import SearchResultTitle from '../../components/SearchResultTitle';

const BlockPage = () => {
    const {lab} = useContext(LabContext);
    const { blockid } = useParams();

    const { isLoading ,data, error, isFetching, isSuccess  } = useQuery(['block-txs', `${blockid}`],  async () => 
        await fetchBlockTxs({blockId: blockid!, env: lab?.env}),
        {
            refetchOnWindowFocus: false, 
            retry: 3
        }
    );

    console.log(data);
    
    
    return (
        <div>
            <SearchResultTitle> 
                Block: <CopyTxtIconBtn fontSize="small" value={blockid || ""}/> {blockid}
            </SearchResultTitle>
            <Divider />
            <LoadingWrapper
                child={
                <div>
                    
                </div>
                }
                isLoading = {isLoading || isFetching}
                error = {!!error}
                isSucceeded={isSuccess}
                errorTxt={`Transaction ${blockid} was not found`}
            />
        </div>
    )
}

export default BlockPage